import {Component, Inject} from '@angular/core';
import {MAT_DIALOG_DATA, MatDialogRef} from '@angular/material/dialog';

import {DialogConfigInterface} from 'appShared/components/dialog';
import {AddExchangeForm} from 'appEntries/panel/forms';
import {ApiError, SesService} from '@spa/api';
import {ExchangeFormErrorStatesEnum} from 'appEntries/panel/enums';
import {ExchangeAddMessages} from 'appAssets/messages';
import {PermissionRuleCheckStrategiesEnum} from 'appShared/enums';
import {AlertsService} from 'appShared/services';
import {PanelBaseMarketDataFormDialogComponent} from 'appEntries/panel/dialogs/ses/panel-base-market-data-form-dialog.component';
import {PermissionRulesTrait} from 'appEntries/panel/traits';

@Component({
    selector: 'app-exchange-add',
    templateUrl: './exchange-add.component.html',
    styleUrls: ['./exchange-add.component.scss']
})
export class ExchangeAddComponent extends PanelBaseMarketDataFormDialogComponent<ExchangeAddComponent> {
    private readonly agreementTypes: Record<string, string>;

    constructor(
        @Inject(MAT_DIALOG_DATA) public data: {
            config: DialogConfigInterface,
            agreementTypes: Record<string, string>,
        },
        private readonly sesService: SesService,
        protected alertsService: AlertsService,
        public dialogRef: MatDialogRef<ExchangeAddComponent>,
    ) {
        super(dialogRef, alertsService);
        this.permissionRule = PermissionRulesTrait.getMarketDataFeedManagementPermissionRule(PermissionRuleCheckStrategiesEnum.Union);
        this.config = data.config;
        this.agreementTypes = data.agreementTypes;
    }

    initForm(): void {
        this.form = new AddExchangeForm(this.sesService, this.agreementTypes);
        this.form.initForm();
    }

    getSuccessFormMessage(): string {
        return ExchangeAddMessages.ExchangeCreationSucceed.message;
    }

    getErrorMessageByApiError(error: ApiError): string {
        if (error.status === ExchangeFormErrorStatesEnum.CreateExchangeFailed) {
            return ExchangeAddMessages.ExchangeCreationFailed.message;
        }

        return ExchangeAddMessages.UnknownError.message;
    }
}
